import { Flex } from 'antd';
import InteractiveCard from '../common/interactiveCard';
import { Divider } from '../Ant';
import CardData from '../dashboard/cardData';
import { Briefcase, FilledNote } from '../icons';
import { useTranslation } from 'react-i18next';
import { ITask } from '../../interface/tasks';
import { getTranslationFromTranslatableEntity } from '../../constants/matter';
import { useLanguage } from '../../context/LanguageContext';
import { getMatterIconClass, getMatterLabel } from '../../constants/utilityFunctions';
import { cardBorderColorMapping, tagColorMapping } from '../../constants/tasks';
interface ActivityCardProps {
  onSelect: () => void;
  activity: ITask;
  isSelected?: boolean;
}
const ActivityCard = ({ onSelect, activity, isSelected }: ActivityCardProps) => {
  const { t } = useTranslation();
  const { getAppLanguageCode } = useLanguage();
  const taskStatus = getTranslationFromTranslatableEntity(
    activity?.status?.translations,
    getAppLanguageCode(),
  );

  return (
    <InteractiveCard
      className={`pointer task-card ${cardBorderColorMapping[activity?.statusId] || cardBorderColorMapping.default} ${isSelected ? 'transaction-active-card' : ''}`}
      onActivate={onSelect}
    >
      <Flex vertical gap={10}>
        <Flex>
          <Flex
            align="center"
            justify="center"
            className={`status-chip ${tagColorMapping[activity?.statusId] || tagColorMapping.default}`}
          >
            {taskStatus}
          </Flex>
        </Flex>
        <Divider />
        <CardData
          icon={<FilledNote />}
          title={t('task:task')}
          content={activity?.subject}
          contentclass="lineclamp-1"
        />
        {activity?.matter && (
          <CardData
            icon={
              <Briefcase className={getMatterIconClass(activity?.matter?.invoiceableType ?? '')} />
            }
            title={getMatterLabel(t, activity?.matter?.invoiceableType ?? '')}
            content={
              activity?.matter?.principalCompany?.name ??
              activity?.matter?.principalPrivatePerson?.fullName ??
              '-'
            }
            contentclass="lineclamp-1"
            subcontentclass="lineclamp-1"
            subcontent={`${activity?.matter?.matterNumber} - ${activity?.matter?.subject}`}
          />
        )}
      </Flex>
    </InteractiveCard>
  );
};

export default ActivityCard;
